import { Autocomplete, FormControl, TextField } from "@mui/material";
import { SyntheticEvent, useCallback } from "react";
import { useSearchNearbyPharmaciesQuery } from "src/api/services/ePrescribeApi";
import { EPrescribePharmacy } from "src/api/types";

interface Props {
  patientId: number;
  onSelect: (pharmacy: EPrescribePharmacy | null) => void;
}

const PharmacySearch = ({ patientId, onSelect }: Props) => {
  const { data: pharmacies = [], isFetching } = useSearchNearbyPharmaciesQuery(
    { patientId },
    { refetchOnMountOrArgChange: true },
  );

  const handleOnChange = useCallback(
    (_: SyntheticEvent, newValue: EPrescribePharmacy | null) => {
      onSelect(newValue);
    },
    [onSelect],
  );

  return (
    <FormControl fullWidth required sx={{ gap: 1 }}>
      <Autocomplete
        loading={isFetching}
        options={pharmacies}
        getOptionLabel={(option) =>
          `${option.StoreName} - ${option.Address1}, ${option.City}, ${option.State} `
        }
        renderInput={(params) => (
          <TextField
            {...params}
            required
            name="pharmacy"
            id="pharmacy"
            label="Search"
          />
        )}
        onChange={handleOnChange}
      />
    </FormControl>
  );
};

export default PharmacySearch;
